if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();
    }

    setRandomAnimationDelay() {
      this.style.setProperty('--animation-delay', `${Math.random()}s`);
      this.style.setProperty(
        '--animation-default-duration',
        `${(Math.random() + 1) * 2.4}s`,
      );
    }

    handleSubmit(event) {
      event.preventDefault();

      this.cartDrawer = document.querySelector('cart-drawer');

      const formData = new FormData(this.form);
      formData.append(
        'sections',
        this.cartDrawer.getSectionsToRender().map((section) => section.section),
      );
      formData.append('sections_url', window.location.pathname);

      Cart.add(formData)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return console.log(response.description);
          }

          this.cartDrawer.renderContents(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {});
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (this.form)
        this.form.addEventListener('submit', this.handleSubmit.bind(this));

      if (this.hasAttribute('js-animation-delay'))
        this.setRandomAnimationDelay();
    }
  }
  customElements.define('card-product', CardProduct);
}
